/**
 * サンプルクラス
 * @constructor
 */
class MangaModal {

  constructor() {
    this.activeClass = 'is-active';
    this.selectedClass = 'is-selected';
    this.init();
  }

  /**
  * 初期化メソッド
  * ページ内に指定された要素（.js-mangaModal）が存在する場合実行する
  */
  init() {
    if (document.querySelector('.js-mangaModalBtn')) {
      this.mangaModalFunc();
    }
  }
  mangaModalFunc() {
    const modal = document.getElementById('mangaModal');
    const btn = document.querySelector('.js-mangaModalBtn');
    const closeBtn = document.querySelector('.m-modal__close--manga');

    // ボタンをクリックしたらモーダルを表示
    btn.addEventListener('click', () => {
      modal.style.display = 'block';
    });

    // モーダル外をクリックしたらモーダルを非表示
    window.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.style.display = 'none';
      }
    });

    // 閉じるボタンをクリックしたらモーダルを非表示
    closeBtn.addEventListener('click', () => {
      modal.style.display = 'none';
    });
  }
}

export default MangaModal;
